module.exports = __webpack_public_path__ + "static/img/zwfy.7b6469ef.png";